import {Component, OnInit} from '@angular/core';
import {NgRedux} from '@angular-redux/store';
import {IAppState} from './reducers/root.reducer';
import {environment} from '../environments/environment';
import {LayerActions} from './reducers/layer.reducer';
import {ActivatedRoute} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {

  constructor(private route: ActivatedRoute, private ngRedux: NgRedux<IAppState>, private translate: TranslateService, private titleService: Title) {
  }

  ngOnInit() {

    this.titleService.setTitle(environment.portal_name);

    this.route.queryParamMap.subscribe(params => {
      const paramLanguage = params.get('language');

      if (paramLanguage && environment.languages.indexOf(paramLanguage) !== -1) {
        this.translate.use(paramLanguage);
      } else {
        this.translate.setDefaultLang(environment.defaultLanguage);
        this.translate.use(environment.defaultLanguage);
      }
    });
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Angular_wig_cropmap_master/src/app/app.component.ts